var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("h5", { staticClass: "mb-5" }, [
        _vm._v(
          " Verificación de identidad para el proveedor de firma: " +
            _vm._s(this.company.firmaAvanzada) +
            " "
        )
      ]),
      _c(
        "b-card",
        [
          _c("div", { staticClass: "d-flex justify-content-around" }, [
            _c("img", {
              staticClass: "mb-4",
              attrs: { src: _vm.stampUrl, alt: "Estampa", width: "300px;" }
            })
          ]),
          _c("verification-form", {
            attrs: { stampUrl: _vm.stampUrl, cuUserData: _vm.cuUserData }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }